export default __webpack_public_path__ + "static/media/NoProfilePic2.e07a2c85.svg";